import { Injectable } from '@angular/core';
import { HttpClient,HttpRequest, HttpEvent } from '@angular/common/http';
import { Driver } from '../models/driver';
import { Observable, from } from 'rxjs';
import { Plants } from '../models/plants';
import { DriverPlants } from '../driver-plants';

@Injectable({
  providedIn: 'root'
})
export class DriverService {

  constructor(private http:HttpClient) { }

  getDrivers(active?:boolean) : Promise<Driver[]> {
    if (active === true || active === false) {
      return this.http.get<Driver[]>('/api/driver', {params:{active: active + ''}})
        .toPromise();
    }
    return this.http.get<Driver[]>('/api/driver')
      .toPromise();
  }

  async postDriver(driver:Driver) : Promise<Driver> {
    return this.http.post<Driver>('/api/driver', driver)
      .toPromise();
  }

  async getDriver(id:Number) : Promise<Driver> {
    return this.http.get<Driver>('/api/driver/' + id)
      .toPromise();
  }
  
  async putDriver(driver:Driver) : Promise<Driver> {
    return this.http.post<Driver>('/api/driver/' + driver.id + '/edit', driver)
      .toPromise();
  }
  
  async deleteDriver(driver:Driver) : Promise<void> {
    return this.http.post<void>('/api/driver/' + driver.id + '/delete', {uncontracted_date: driver.uncontracted_date.toString(), uncontracted_description: driver.uncontracted_description.toString()})
      .toPromise();
  }

  uploadAvatar(driver:Driver,avatar):Observable<Driver>{
    const formData:FormData = new FormData();
    formData.append('avatar',avatar);
    formData.append('driver',(driver.id).toString());
    return this.http.post<Driver>('/api/driver/avatar', formData);
  }

  postFile(formData:FormData) : Observable<any>{
    return this.http.post<Driver>('/api/driver/files', formData);
  }

  downloadFile(driver : Driver, file : String):Observable<any>{
    return this.http.get('/api/driver/'+driver.id +'/file/'+file+'/get', { responseType: 'blob' });
  }

  getAllPlants(): Promise<Plants[]>{
    return this.http.get<Plants[]>('/api/all/plants').toPromise();
  }

  updatePlants(id: number, driverPlants: Plants[]): Promise<Driver[]>{
    return this.http.post<Driver[]>('/api/update/driver-plants', {params:{'data': JSON.stringify(driverPlants), 'driver_id': JSON.stringify(id)}}).toPromise();
  }

// #region Particualar Drivers
  getParticularDrivers() : Promise<any> {
    return this.http.get('/api/particular/drivers')
      .toPromise();
  }
// #endregion

}
